import BigLogo from "@publicPortal/components/bigLogo/BigLogo";
import Board from "@publicPortal/components/board/Board";
import ResultBoard from "@publicPortal/components/resultBoard/ResultBoard";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";
import LoginBoilerplate from "@mirage/components/login/LoginBoilerplate";
import { memo, useCallback, useState } from "react";
import PublicLoginButtons from "./PublicLoginButtons";
import ApplicationService from "@mirage/services/ApplicationService";
import { useStableNavigate } from "@mirage/hooks/useStableNavigate";
import { useUserStore } from "@mirage/store/store";
import { UserStore } from "@mirage/store/UserStore";
import { PPConstants } from "@shared/publicportal/constants";
import { useInitializeUserSession } from "@mirage/hooks/useInitializeUserSession";
import "./PublicLogin.css";

const pp = new PublicPortalRoutingService();

const PublicLogin = memo(() => {
    const setUser = useUserStore((state) => state.setUser);
    const navigate = useStableNavigate();
    const clearUserAtom = useCallback(() => setUser({} as UserStore), [setUser]);
    const logoutNavigate = () => navigate(pp.Root);
    const userService = new ApplicationService({ clearUserAtom, logoutNavigate });
    const [showResultBoard, setShowResultBoard] = useState(false);
    const [emailAddress, setEmailAddress] = useState("");
    const setInitialUser = useInitializeUserSession(pp.Root);
    const onAfterLoginSuccess = useCallback(() => {
        setInitialUser(PPConstants.AppName);
    }, [setInitialUser]);

    const errorHandler = (error: string, email: string, serverValidationHandler: (error: string, passed: boolean) => void) => {
        if (error === "Email is not confirmed.") {
            setEmailAddress(email);
            setShowResultBoard(true);
        } else {
            serverValidationHandler(error, false);
        }
    };

    const loginBoard = (
        <Board headerText="Sign In" size="small" data-testid="publicportal-login-component" className="publicLoginBoard">
            <LoginBoilerplate
                appName="publicportal"
                Buttons={PublicLoginButtons}
                navigateTo={pp.Root}
                service={userService}
                fieldSize={"medium"}
                customErrorHandler={errorHandler}
                onAfterLoginSuccess={onAfterLoginSuccess}
            />
        </Board>
    );

    const resultBoard = (
        <ResultBoard headerText="Login" loading={false} success={false} buttonLabel={"Back to Main Page"} buttonNavTo={pp.Root} message={"Your email is not confirmed."}>
            <p>We have sent confirmation email to:</p>
            <b>{emailAddress}</b>
            <p>Please check your inbox to continue.</p>
        </ResultBoard>
    );

    return (
        <>
            <BigLogo navigateTo={pp.Root} disableRedirectToBlank />
            {showResultBoard ? resultBoard : loginBoard}
        </>
    );
});

export default PublicLogin;
